import React, { useState, useRef, useEffect } from 'react';
import './SiteNav.css';

function SiteNav({ user, lastUpdate }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return;
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    const t = setTimeout(() => document.addEventListener('click', handleClickOutside), 0);
    return () => {
      clearTimeout(t);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [menuOpen]);

  const handleLogout = async () => {
    setMenuOpen(false);
    try {
      await fetch('/api/auth.php?action=logout', { credentials: 'include' });
      window.location.href = '/api/auth.php?action=login&prompt=select_account';
    } catch (error) {
      console.error('Logout failed:', error);
      window.location.href = '/api/auth.php?action=login&prompt=select_account';
    }
  };

  return (
    <header className="header">
      <div className="header-left">
        <h1>WebScraper Dashboard</h1>
        <div className="header-subtitle">
          Last updated: <span>{lastUpdate ? lastUpdate.toLocaleTimeString() : '--:--:--'}</span>
        </div>
      </div>
      <div className="header-right">
        <div className="user-info">
          {user?.avatar && <img src={user.avatar} alt="" className="user-avatar" />}
          <span>{user?.name}</span>
        </div>
        <div className="hamburger-wrap" ref={menuRef}>
          <button
            type="button"
            className="hamburger-btn"
            onClick={(e) => {
              e.stopPropagation();
              setMenuOpen((o) => !o);
            }}
            aria-expanded={menuOpen}
            aria-haspopup="true"
            aria-label="Open menu"
          >
            <span className="hamburger-bar" />
            <span className="hamburger-bar" />
            <span className="hamburger-bar" />
          </button>
          {menuOpen && (
            <div className="hamburger-menu">
              <a href="/webScraper/" className="hamburger-item" onClick={() => setMenuOpen(false)}>
                Web Scraper
              </a>
              <a href="/foodNstuff/" className="hamburger-item" onClick={() => setMenuOpen(false)}>
                Food N Stuff
              </a>
              <button type="button" className="hamburger-item hamburger-logout" onClick={handleLogout}>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default SiteNav;
